"use client";

import { getQualityColor } from "./utils";

const CHOGHADIYA_MEANINGS = [
  {
    name: "Amrit (अमृत)",
    quality: "best",
    meaning: "Nectar / Highest Good",
    bestFor: "All auspicious tasks, holy puja, travel, medical treatments",
  },
  {
    name: "Shubh (शुभ)",
    quality: "best",
    meaning: "Auspicious / Sacred",
    bestFor: "Ceremonies, marriage talks, purchasing property, study",
  },
  {
    name: "Labh (लाभ)",
    quality: "good",
    meaning: "Profit / Gain",
    bestFor: "New business ventures, opening accounts, trade, investments",
  },
  {
    name: "Char (चल)",
    quality: "neutral",
    meaning: "Movement / Dynamic",
    bestFor: "Journeys, vehicle driving, commuting, short-term tasks",
  },
  {
    name: "Rog (रोग)",
    quality: "bad",
    meaning: "Affliction / Disease",
    bestFor: "Inauspicious — avoid starting major projects or medicines",
  },
  {
    name: "Kaal (काल)",
    quality: "bad",
    meaning: "Loss / Inauspicious",
    bestFor: "Inauspicious — strictly avoid financial risks or new journeys",
  },
  {
    name: "Udveg (उद्वेग)",
    quality: "bad",
    meaning: "Anxiety / Stress",
    bestFor: "Inauspicious — avoid official disputes or government work",
  },
];

export function ChoghadiyaLegend() {
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap justify-center gap-3 text-caption font-medium">
        {[
          { label: "Best (Amrit, Shubh)", quality: "best" },
          { label: "Good (Labh)", quality: "good" },
          { label: "Neutral (Char)", quality: "neutral" },
          { label: "Avoid (Rog, Kaal, Udveg)", quality: "bad" },
        ].map(({ label, quality }) => {
          const colors = getQualityColor(quality);
          return (
            <span key={quality} className="flex items-center gap-1.5">
              <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: colors.text }} />
              <span className="text-text-secondary">{label}</span>
            </span>
          );
        })}
      </div>

      <div className="overflow-x-auto rounded-lg border border-border-subtle bg-surface-raised p-3">
        <table className="w-full text-left text-body-small">
          <thead>
            <tr className="border-b border-border-subtle text-caption uppercase text-text-secondary">
              <th className="py-2 px-2">Choghadiya</th>
              <th className="py-2 px-2">Quality</th>
              <th className="py-2 px-2">Recommended Activities</th>
            </tr>
          </thead>
          <tbody className="divide-y border-border-subtle">
            {CHOGHADIYA_MEANINGS.map((item) => (
              <tr key={item.name} className="hover:bg-surface-pressed transition">
                <td className="py-2 px-2 font-semibold text-text-primary">{item.name}</td>
                <td className="py-2 px-2">
                  <span className="text-caption font-semibold px-2 py-0.5 rounded-full border border-border-subtle inline-block">
                    {item.meaning}
                  </span>
                </td>
                <td className="py-2 px-2 text-text-secondary">{item.bestFor}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
